module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_163130_HDR-removebg-preview-8cc998fb68380c2bd08e679a6d4c7599.png";